// Module
var code = "<h1 id=\"report-templates\">Report Templates</h1> <p>This tab is where existing report templates are viewed and created.</p> <p>Templates are given a name and description as well as the character limits set out for comments on subjects and students.</p> <p>Background images are also added here according to campus preference.</p> ";
// Exports
module.exports = code;